import { DealFooterAttribute } from './DealFooterAttribute'

export default DealFooterAttribute
